import React from "react";

/**
 * Pastille ronde rouge avec compteur de notifications non lues.
 * Conçue pour être placée à côté d'une entrée de menu (sidebar) ou d'un
 * déclencheur d'onglet. N'apparaît que si `count > 0`.
 */
export default function MenuBadge({ count, size = "sm", className = "", testid }) {
  if (!count || count <= 0) return null;
  const label = count > 99 ? "99+" : String(count);
  const sizeCls =
    size === "xs"
      ? "min-w-[15px] h-[15px] text-[9px] px-1"
      : "min-w-[17px] h-[17px] text-[10px] px-1";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-red-600 text-white font-mono font-semibold leading-none ${sizeCls} ${className}`}
      data-testid={testid}
      aria-label={`${count} notifications non lues`}
      title={`${count} notification${count > 1 ? "s" : ""} non lue${count > 1 ? "s" : ""}`}
    >
      {label}
    </span>
  );
}
